import classNames from "classnames";
import plainAmountRowStyles from "./PlainAmountRow.module.css";
import amountRowBaseStyles from "./AmountRowBase.module.css";
import { type PropsWithChildren, type JSX } from "react";
import { Trans } from "react-i18next";
import { ValueWithCurrency } from "../ValueWithCurrency";

type PlainAmountRowVariants = "large" | "small";

type PlainAmountRowProps = {
  labelKey?: string;
  label?: string;
  value?: number;
  isTotal?: boolean;
  withSublistingStyles?: boolean;
  variant?: PlainAmountRowVariants;
} & PropsWithChildren;

const PlainAmountRow = (props: PlainAmountRowProps): JSX.Element => {
  const { children, labelKey, value, isTotal = false, withSublistingStyles = false, variant = "large" } = props;

  const rowClasses = classNames(plainAmountRowStyles.plainAmountRow, amountRowBaseStyles.amountRow, {
    [amountRowBaseStyles.totalRowLarge]: isTotal && variant === "large",
    [amountRowBaseStyles.totalRowSmall]: isTotal && variant === "small",
  });
  return (
    <>
      <tr className={`${rowClasses} ${amountRowBaseStyles.mainRow}`}>
        <td>{props.labelKey ? <Trans i18nKey={labelKey}></Trans> : props.label}</td>
        <td className={amountRowBaseStyles.amount}>
          <ValueWithCurrency value={value!} />
        </td>
      </tr>
      {children && (
        <tr className={`${rowClasses} ${amountRowBaseStyles.subRow}`}>
          <td colSpan={2}>
            <div
              className={classNames(plainAmountRowStyles.additionContent, {
                [plainAmountRowStyles.withSublistingStyles]: withSublistingStyles,
              })}
            >
              {children}
            </div>
          </td>
        </tr>
      )}
    </>
  );
};

export { PlainAmountRow };
